// public/js/features/user-analytics/api.js
export async function loadLive() {
  const res = await window.authenticatedFetch('api/v1/analytics/live');
  if (!res.ok) throw new Error(`live ${res.status}`);
  return res.json();   // { users, counts }
}

export async function loadOverview(days = 7) {
  const res = await window.authenticatedFetch(`api/v1/analytics/overview?days=${encodeURIComponent(days)}`);
  if (!res.ok) throw new Error(`overview ${res.status}`);
  return res.json();
}

export async function loadUsersSummary(days = 30) {
  const res = await window.authenticatedFetch(`api/v1/analytics/users?days=${encodeURIComponent(days)}`);
  if (!res.ok) throw new Error(`users ${res.status}`);
  return (await res.json()).users || [];
}

export async function loadUserHistory(userId) {
  const res = await window.authenticatedFetch(`api/v1/analytics/user/${encodeURIComponent(userId)}`);
  if (!res.ok) throw new Error(`user ${res.status}`);
  return (await res.json()).events || [];
}
